import {
  faBadgeCheck,
  faCalendarLinesPen,
  faCheckCircle,
  faCircleInfo,
  faClock,
  faCloudArrowUp,
  faCloudXmark,
  faCommentDots,
  faEnvelope,
  faPhone,
  faSplit,
  faTrash,
  faUser as faUserRegular
} from "@fortawesome/pro-regular-svg-icons";
import {
  faArrowDown,
  faArrowLeftArrowRight,
  faArrowsRotate,
  faArrowUp,
  faBan,
  faBell,
  faBug,
  faBuilding,
  faBuildingColumns,
  faCalendarAlt,
  faCalendarClock,
  faCheck,
  faCheckDouble,
  faCircleHalfStroke,
  faClockRotateLeft,
  faCopy,
  faCreditCard,
  faDoorOpen,
  faDownload,
  faEnvelopeOpenDollar,
  faEuroSign,
  faExclamation,
  faExclamationTriangle,
  faEye,
  faFileContract,
  faFileExcel,
  faFileImage,
  faFileInvoiceDollar,
  faFilePdf,
  faFilePowerpoint,
  faFileSignature,
  faFileWord,
  faFilter,
  faFlagCheckered,
  faGridHorizontal,
  faHandHoldingDollar,
  faHandshake,
  faInbox,
  faKey,
  faMobileScreenButton,
  faMoneyBillTransfer,
  faMoneyCheckDollar,
  faPaperPlane,
  faPiggyBank,
  faPlus,
  faRotateLeft,
  faSackDollar,
  faSackXmark,
  faSearch,
  faShield,
  faSignature,
  faThumbtack,
  faThumbTackSlash,
  faTimes,
  faToolbox,
  faTriangleExclamation,
  faUndo,
  faUpload,
  faUser,
  faUsers,
  faUserTie,
  faXmarkToSlot
} from "@fortawesome/pro-solid-svg-icons";

const icons = [
  faUsers,
  faUser,
  faSearch,
  faFileContract,
  faTriangleExclamation,
  faBuilding,
  faPaperPlane,
  faEuroSign,
  faCheck,
  faTimes,
  faCalendarAlt,
  faCalendarClock,
  faDownload,
  faUserTie,
  faPiggyBank,
  faCheckCircle,
  faClock,
  faBell,
  faBadgeCheck,
  faCircleHalfStroke,
  faCopy,
  faEnvelopeOpenDollar,
  faFilter,
  faSplit,
  faKey,
  faXmarkToSlot,
  faRotateLeft,
  faGridHorizontal,
  faArrowUp,
  faArrowDown,
  faEye,
  faCheckDouble,
  faSignature,
  faToolbox,
  faHandHoldingDollar,
  faSackDollar,
  faInbox,
  faBan,
  faUndo,
  faExclamationTriangle,
  faExclamation,
  faDoorOpen,
  faSackXmark,
  faCircleInfo,
  faArrowsRotate,
  faFileInvoiceDollar,
  faThumbtack,
  faThumbTackSlash,
  faEnvelopeOpenDollar,
  faMobileScreenButton,
  faFileInvoiceDollar,
  faFileSignature,
  faBuildingColumns,
  faEuroSign,
  faMoneyCheckDollar,
  faUpload,
  faClockRotateLeft,
  faShield,
  faFlagCheckered,
  faFilePdf,
  faFileExcel,
  faFileWord,
  faFileImage,
  faFilePowerpoint,
  faMoneyBillTransfer,
  faCreditCard,
  faEnvelope,
  faPlus,
  faPhone,
  faCommentDots,
  faUserRegular,
  faTrash,
  faCloudArrowUp,
  faCloudXmark,
  faCalendarLinesPen,
  faArrowLeftArrowRight,
  faHandshake,
  faBug
];

const aliases = {
  notification: "fas fa-bell",
  theme: "fas fa-circle-half-stroke",
  filter: "fas fa-filter",
  bug: "fas fa-bug",

  funder: "fas fa-piggy-bank",
  financeReceiver: "fas fa-hand-holding-dollar",
  loan: "fas fa-file-invoice-dollar",
  consumer: "fas fa-user",
  business: "fas fa-building",
  partner: "fas fa-user-tie",
  user: "fas fa-user",
  search: "fas fa-search",
  fundingContract: "fas fa-file-contract",
  admin: "fas fa-key",
  dashboard: "fas fa-grid-horizontal",
  toolbox: "fas fa-toolbox",

  fundingContractStatusDraft: "fas fa-pencil",
  fundingContractStatusSent: "fas fa-paper-plane",
  fundingContractStatusAccepted: "fas fa-signature",
  fundingContractStatusValidated: "fas fa-check-double",
  fundingContractStatusActive: "fas fa-euro-sign",
  fundingContractStatusInactive: "fas fa-times",

  financeReceiverStatusPreScanSubmitted: "fas fa-inbox",
  financeReceiverStatusPreScanInProgress: "far fa-clock",
  financeReceiverStatusPreScanRejected: "fas fa-ban",
  financeReceiverStatusPreScanWithdrawn: "fas fa-undo",
  financeReceiverStatusInactive: "fas fa-times",
  financeReceiverStatusActive: "fas fa-euro-sign",
  financeReceiverStatusDelinquent: "fas fa-exclamation-triangle",
  financeReceiverStatusDefaulting: "fas fa-exclamation",
  financeReceiverStatusOffboarded: "fas fa-door-open",

  contractSent: "fas fa-paper-plane",

  loanStatusRequested: "fas fa-envelope-open-dollar",
  loanStatusApproved: "fas fa-calendar-clock",
  loanStatusApprovedRenewal: "fas fa-calendar-clock",
  loanStatusApprovedAndPaid: "fas fa-sack-dollar",
  loanStatusRejected: "fas fa-xmark-to-slot",
  loanStatusCompletedAndRefunded: "fas fa-rotate-left",
  loanStatusDefaulting: "fas fa-triangle-exclamation",
  loanStatusIrrecoverable: "fas fa-sack-xmark",
  loanStatusDirectDebitProcessing: "fas fa-money-bill-transfer",
  loanRenewal: "fas fa-arrows-rotate",
  loanEarlyRepayment: "fas fa-clock-rotate-left",

  directDebitStatusScheduled: "far fa-clock",
  directDebitStatusSuccessful: "fas fa-check",
  directDebitStatusFailed: "fas fa-triangle-exclamation",
  directDebitStatusCancelled: "fas fa-times",
  directDebitStatusProcessing: "fas fa-money-bill-transfer",

  isCollectionDateUpcoming: "far fa-circle-info",

  true: "fas fa-check",
  false: "fas fa-times",

  pin: "fas fa-thumbtack",
  unpin: "fas fa-thumbtack-slash",

  card: "fas fa-credit-card",

  calender: "fas fa-calendar-alt",
  download: "fas fa-download",
  open: "fas fa-eye",
  copy: "fas fa-copy",
  trash: "far fa-trash",

  waiting: "far fa-clock",
  undo: "fas fa-undo",
  deviation: "far fa-split",
  done: "far fa-check-circle",

  warning: "fas fa-triangle-exclamation",

  tasksDone: "far fa-badge-check",

  up: "fas fa-arrow-up",
  down: "fas fa-arrow-down",
  add: "fas fa-plus",

  filePdf: "fas fa-file-pdf",
  fileWord: "fas fa-file-word",
  fileExcel: "fas fa-file-excel",
  fileImage: "fas fa-file-image",
  filePowerpoint: "fas fa-file-powerpoint",

  FinanceReceiverOnboardingValidationStepPreScanAccepted: "fas fa-check",
  FinanceReceiverOnboardingValidationStepInviteToApp: "fas fa-envelope-open-dollar",
  FinanceReceiverOnboardingValidationStepQuoteAndFrameworkAgreement: "fas fa-file-signature",
  FinanceReceiverOnboardingValidationStepSepa: "fas fa-money-check-dollar",
  FinanceReceiverOnboardingValidationStepPsd: "fas fa-building-columns",
  FinanceReceiverOnboardingValidationStepTreatmentFee: "fas fa-euro-sign",
  FinanceReceiverOnboardingValidationStepCollaterals: "fas fa-shield",
  FinanceReceiverOnboardingValidationStepActivateFacility: "fas fa-flag-checkered",

  disconnectBankAccount: "far fa-cloud-xmark",
  connectBankAccount: "far fa-cloud-arrow-up",

  refinancingCredit: "fas fa-paper-plane",
  refinancingCollaterals: "fas fa-handshake",

  message: "far fa-envelope",

  addNote: "far fa-calendar-lines-pen",

  Email: "far fa-envelope",
  InPerson: "far fa-user",
  Phone: "far fa-phone",
  Other: "far fa-comment-dots",

  companyUpdates: "fas fa-arrow-left-arrow-right",

  CreditLimitRequestValidationStepCreditLimitRequestCreated: "fas fa-check",
  CreditLimitRequestValidationStepQuote: "fas fa-file-signature",
  CreditLimitRequestValidationStepSepa: "fas fa-money-check-dollar",
  CreditLimitRequestValidationStepPsd: "fas fa-building-columns",
  CreditLimitRequestValidationStepCollaterals: "fas fa-shield",
  CreditLimitRequestValidationStepActivateCreditLimit: "fas fa-flag-checkered"
};

export default {
  aliases,
  icons
};
